import { useMutation, gql } from '@apollo/client';
import {
  EditarPeriodoMutation,
  EditarPeriodoMutationVariables,
} from './__generated__/EditarPeriodoMutation';

const EDITAR_PERIODO_MUTATION = gql`
  mutation EditarPeriodoMutation(
    $id_periodo: Int!
    $dsc_periodo: String
    $dat_inicio: String
    $dat_fim: String
  ) {
    editarPeriodo(
      input: {
        id_periodo: $id_periodo
        dsc_periodo: $dsc_periodo
        dat_inicio: $dat_inicio
        dat_fim: $dat_fim
      }
    ) {
      id_periodo
      dsc_periodo
      dat_inicio
      dat_fim
    }
  }
`;

const useEditarPeriodoMutation = () => {
  return useMutation<EditarPeriodoMutation, EditarPeriodoMutationVariables>(
    EDITAR_PERIODO_MUTATION
  );
};

export { useEditarPeriodoMutation };
